export default __webpack_public_path__ + "locales/en/SingleSignOn.json?hash=530e95bd33be9c6f4b9f9b6f3aacdfb3";